
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fiis/[tickerSymbol]",
      function () {
        return require("private-next-pages/fiis/[tickerSymbol]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fiis/[tickerSymbol]"])
      });
    }
  